// extracted by css-extract-rspack-plugin
export default {"cls1":"FilterPanel-cls1_308","cls2":"FilterPanel-cls2_oyB FilterPanel-cls1_308"};